import { Device, DeviceInfo } from '@capacitor/device'
import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { Utils } from '../../utils'

export interface IDeviceInfoState {
    deviceInfo: DeviceInfo
    version: {
        buildVersion: string
        reactVersion: string
    }
}

export const useDeviceInfo = create<IDeviceInfoState>()(
    subscribeWithSelector(
        devtools(
            (set, _) => {
                Device.getInfo().then((info) => {
                    set({ deviceInfo: info })
                })

                return {
                    deviceInfo: null,
                    version: {
                        buildVersion: '',
                        reactVersion: '',
                    },
                }
            },
            { name: 'deviceInfo' }
        )
    )
)

setTimeout(() => {
    useDeviceInfo.subscribe(
        (state) => {
            return null
        },
        (state) => {
            const getVersion = async () => {
                useDeviceInfo.setState({
                    version: {
                        buildVersion: await Utils.getVersion(),
                        reactVersion: await Utils.getReactVersion(),
                    },
                })
            }
            getVersion()
        },
        {
            fireImmediately: true,
        }
    )
}, 100)
